import { http } from 'services/http';
import type { TGetTransportsRes, UpdateTransportReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';
import { TRANSPORTS_LIST } from '../query-keys.ts';

export const useUpdateTransport = (transportId: number) => {
  return useMutationBase<TGetTransportsRes, unknown, UpdateTransportReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<TGetTransportsRes>(`/v1/transports/${transportId}`, variables);

      return res.data;
    },

    invalidateCallback: () => [[TRANSPORTS_LIST]],
  });
};
